import { PlanBadgeText } from './PlanBadgeText';
import { useGetHighestHeight } from '../hooks/useGetHighestHeight';
import type { ComparisonTablePlan } from '../types';

interface Props {
  plans: ComparisonTablePlan[];
}

export const PlanBadgeTextContainer = ({ plans }: Props) => {
  useGetHighestHeight('.plan-item-container__badge-text', { cssVarName: '--badge-height', disableStateUpdates: true });

  return plans.map(({ id, badgeText }) => badgeText && <PlanBadgeText key={id} badgeText={badgeText} planId={id} />);
};
